import { Component, OnInit } from '@angular/core';

import { AccountComponent } from '../../account/account/account.component';
import { PolicyComponent } from '../../policy/policy.component';
import { NavigationService } from '../../core/services/navigation.service';

@Component({
  selector: 'dx-billing-statements-tab',
  templateUrl: './billing-statements-tab.component.html',
  styleUrls: ['./billing-statements-tab.component.scss']
})
export class BillingStatementsTabComponent implements OnInit {
  accountNumber: string;
  policyNumber: string;

  constructor(private navigationService: NavigationService) { }

  ngOnInit() {
    let route = this.navigationService.getRouteByComponent(AccountComponent);

    if (!route) {
      route = this.navigationService.getRouteByComponent(PolicyComponent);
    }

    if (route) {
      route.paramMap.subscribe((params) => {
        this.accountNumber = params.get('accountNumber');
        this.policyNumber = params.get('policyNumber');
      });
    }
  }
}
